var _rect, _rect2, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhase3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 204,
    viewBox: "0 0 208 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119.25,
    height: 119.25,
    rx: 11,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 0.890625 144.378)",
    fill: "url(#paint0_linear_541_16726)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 87.108,
    height: 87.108,
    rx: 14,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 28.6641 143.533)",
    fill: "url(#paint1_linear_541_16726)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0222 127.765C73.5634 162.996 135.33 162.996 142.136 127.765C148.941 92.5347 148.999 79.262 148.999 79.262C148.999 42.4667 60.1592 42.4667 60.1592 79.262C60.1592 79.262 60.4809 92.5347 67.0222 127.765Z",
    fill: "#F2994A",
    stroke: "#C16C20",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0222 127.765C73.5634 162.996 135.33 162.996 142.136 127.765C148.941 92.5347 148.999 79.262 148.999 79.262C148.999 42.4667 60.1592 42.4667 60.1592 79.262C60.1592 79.262 60.4809 92.5347 67.0222 127.765Z",
    stroke: "#F2994A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5578 132.71C67.2068 131.147 67.0222 129.499 67.0222 127.765L60.1592 79.262C60.1592 42.4667 148.999 42.4667 148.999 79.262L147.631 88.9247C137.185 115.2 111.035 133.828 80.4275 133.828C76.0347 133.828 71.7337 133.444 67.5578 132.71Z",
    fill: "#FEAD66"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.448,
    cy: 65.1985,
    rx: 30.8834,
    ry: 10.2945,
    fill: "#C97A35",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.437 32.1716C100.015 43.071 104.261 58.8944 104.261 58.8944C104.261 58.8944 120.54 57.0465 127.961 46.1471C135.383 35.2478 131.137 19.4244 131.137 19.4244C131.137 19.4244 114.859 21.2723 107.437 32.1716Z",
    fill: "#2BA725"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.604 34.3149C121.604 53.2664 104.446 68.6297 104.446 68.6297C104.446 68.6297 87.2891 53.2664 87.2891 34.3149C87.2891 15.3633 104.446 0 104.446 0C104.446 0 121.604 15.3633 121.604 34.3149Z",
    fill: "#3CD035"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.638 45.1793C107.305 54.9699 103.491 69.1835 103.491 69.1835C103.491 69.1835 88.8683 67.5236 82.2018 57.7331C75.5352 47.9425 79.3491 33.7289 79.3491 33.7289C79.3491 33.7289 93.9716 35.3888 100.638 45.1793Z",
    fill: "#388134"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_541_16726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.173 63.423L148.329 75.7518L144.863 77.4416L140.173 63.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.019 89.7713L148.329 75.7518L144.863 77.4416L153.019 89.7713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.421 83.018L145.75 74.8624L147.44 78.3284L133.421 83.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.769 70.1722L145.75 74.8624L147.44 78.3284L159.769 70.1722Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_541_16726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3727 109.37L69.5333 121.446L66.4726 120.56L71.3727 109.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.633 132.637L69.5333 121.446L66.4726 120.56L64.633 132.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3698 117.632L68.4464 119.471L67.5598 122.532L56.3698 117.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6372 124.372L68.4464 119.471L67.5598 122.532L79.6372 124.372Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_541_16726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.0188 3.26264L99.0731 8.85309L97.4893 9.71143L95.0188 3.26264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.544 15.3023L99.0731 8.85309L97.4893 9.71143L101.544 15.3023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2611 12.5441L97.8516 8.48978L98.7099 10.0735L92.2611 12.5441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.301 6.01893L97.8516 8.48978L98.7099 10.0735L104.301 6.01893Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_541_16726",
    x: 132.421,
    y: 62.423,
    width: 28.3486,
    height: 28.3484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_541_16726"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_541_16726",
    x: 55.3701,
    y: 108.37,
    width: 25.2676,
    height: 25.2673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_541_16726"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_541_16726",
    x: 91.2607,
    y: 2.2627,
    width: 14.04,
    height: 14.0396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_541_16726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_541_16726",
    x1: 45.1329,
    y1: -14.4922,
    x2: 83.8873,
    y2: 174.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133966,
    stopColor: "#95764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E653C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_541_16726",
    x1: 32.968,
    y1: -10.586,
    x2: 61.2767,
    y2: 127.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133966,
    stopColor: "#95764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E653C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase3);
export default __webpack_public_path__ + "static/media/phase3.98e7c9dfb646d269d958a97b2d78aa83.svg";
export { ForwardRef as ReactComponent };